import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router'

import { Dropdown, DropdownItem } from '../../../styles/defaults-header'

class CompanyMenu extends Component {
  handleClick(e) {
    this.props.onClickLink(e)
  }

  render() {
    const current = this.props.history.location.pathname
    return (
      <Dropdown>
        <DropdownItem current={current === '/mijn-bedrijf/bedrijfsgegevens'}>
          <Link to="/mijn-bedrijf/bedrijfsgegevens" onClick={this.handleClick.bind(this)}>
            Bedrijfsgegevens
          </Link>
        </DropdownItem>

        {this.props.permissions.viewOldOrders ? (
          <DropdownItem current={current === '/mijn-bedrijf/orderhistorie'}>
            <Link to="/mijn-bedrijf/orderhistorie" onClick={this.handleClick.bind(this)}>Orderhistorie</Link>
          </DropdownItem>
        ) : null}

            
        {this.props.permissions.viewInvoices ? (
          <DropdownItem current={current === '/mijn-bedrijf/facturen'}>
            <Link to="/mijn-bedrijf/facturen" onClick={this.handleClick.bind(this)}>
              Facturen
            </Link>
          </DropdownItem> 
        ) : null}

        {this.props.permissions.viewTech ? (
          <DropdownItem current={current === '/mijn-bedrijf/technische-gegevens'}>
            <Link to="/mijn-bedrijf/technische-gegevens" onClick={this.handleClick.bind(this)}>
              Technische gegevens
            </Link>
          </DropdownItem> 
        ) : null}
      </Dropdown>
    )
  }
}

export default withRouter(CompanyMenu)



// WEBPACK FOOTER //
// ./src/components/Header/CompanyMenu/index.js